import React from 'react';
import { Auth } from 'aws-amplify';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { ListItemButton, ListItemIcon, Typography } from '@mui/material';
import { SESSION_TIMEOUT_COOKIE_NAME } from '../../constants/common';
//@ts-ignore
import Cookies from 'js-cookie';

export const LogoutNavItem = () => {
  const handleLogout = async () => {
    await Auth.signOut();
    Cookies.remove(SESSION_TIMEOUT_COOKIE_NAME);
    localStorage.clear();
    sessionStorage.clear();
    document.location.pathname = '';
  };

  return (
    <ListItem disablePadding onClick={handleLogout} className="nestedNavList">
      <ListItemButton className="nestedNavListButton">
        <ListItemIcon className="nestedNavListButtonIcon">
          <ExitToAppIcon />
        </ListItemIcon>

        <ListItemText
          className="nestedNavListButtonText"
          primary={<Typography variant="body1">Logout</Typography>}
          disableTypography
        />
      </ListItemButton>
    </ListItem>
  );
};
